<template>
  <div class="vertical-stepper">
    <div
      v-for="(step, index) in steps"
      :key="index"
      class="step"
      :class="{ active_step: index === active }"
    >
      <div class="step-circle-container">
        <div class="step-circle">
          <img
            class="step-icon"
            v-if="index === active"
            src="@/assets/img/loader.svg"
            alt=""
          />
        </div>
      </div>
      <div>
        <div class="step-label d-flex align-items-center">{{ step.label }}
        <img v-if="index < active" class="icon ml-1" src="@/assets/img/done.svg" alt="" />
        </div>
        <div class="step-sublabel" v-if="index === active">
          {{ step.subLabel }}
        </div>
      </div>
    </div>
    <div class="info-container">
      <div class="d-flex">
        <img class="mr-2" src="@/assets/img/loader.svg" alt="" />
        <div class="info-container__title">Did you know section?</div>
      </div>

      <div class="info-container__subtitle mt-2">Lorem idivsum dolor</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    steps: Array,
    active: Number,
  },
};
</script>

<style lang="scss" scoped>
.vertical-stepper {
  background: rgba(87, 87, 245, 0.1);
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  align-content: center;
  justify-content: center;
  width: 100%;
}

.step {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 5px;
  width: auto;
  z-index: 0;
  margin-bottom: 20px;
}

.step.active_step .step-circle {
  background-color: #fff; /* Active circle background color */
  width: 26px;
  height: 26px;
}

.step-circle-container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  margin-right: 10px; /* Adjust margin between circle and label */
}

.step-circle {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background-color: #fff; /* Default circle background color */
  display: flex;
  align-items: center;
  justify-content: center;
}
.step-circle::after {
  content: "";
  border-left: 2px dashed #fff;
  z-index: 0;
  position: absolute;
  margin-left: 0;
  height: 50px;
  margin-top: 40px;
  z-index: -1;
}

.step-label {
  font-size: 14px;
  font-weight: 700;
  line-height: 18px;
  letter-spacing: 0em;
  text-align: left;
  color: rgba(4, 25, 57, 1);
}
.step-sublabel {
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  letter-spacing: 0em;
  text-align: left;
  color: rgba(4, 25, 57, 1);
}

.step-icon {
  animation: spin 2s linear infinite;
  border-radius: 50%;
}
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
/* .step:last-child .step-circle::after {
  content: none;
} */
.info-container {
  border: 1px solid rgba(87, 87, 245, 1);
  padding: 10px;
  margin: 10px;
  border-radius: 5px;
  &__title {
    font-size: 14px;
    font-weight: 700;
    line-height: 18px;
    letter-spacing: 0em;
    text-align: left;
  }
  &__subtitle {
    font-size: 12px;
    font-weight: 500;
    line-height: 16px;
    letter-spacing: 0em;
    text-align: left;
  }
}
.icon {
  width: 16px;
  height: 16px;
}
</style>
